import React, { useRef } from 'react';
//import { useTranslation } from 'react-i18next';
import GenericIconButton from '../GenericComponents/GenericIconButton';
import styles from './Menu.module.css';

type MenuProps = {
    mainY: number;
    setAndKeepMainY: (newMainY: number, prevMainY: number) => void;
    scrollBack: () => void;
};

const Menu: React.FC<MenuProps> = ({ scrollBack }) => {
    const topRef = useRef<HTMLDivElement | null>(null);
    //const { t } = useTranslation();

    const footerStyle: React.CSSProperties = {
        height: '40px',
        marginTop: '10px',
    };

    const hrStyle: React.CSSProperties = {
        borderTop: '1px solid #F1EFEC',
        background: 'transparent',
    };

    const linkStyle: React.CSSProperties = {
        textDecoration: 'none',
        color: '#fff', // Dit is wit zoals in het tweede bestand
    };

    const leftLinkStyle: React.CSSProperties = {
        float: 'left',
        marginLeft: '10px',
    };

    const middleLinkStyle: React.CSSProperties = {
        marginLeft: '20px',
    };

    const rightLinkStyle: React.CSSProperties = {
        float: 'right',
        marginRight: '20px',
    };

    const rightMostLinkStyle: React.CSSProperties = {
        float: 'right',
        marginRight: '50px',
    };

    return (
        <div className={styles.Menu}>
            <div className={styles.menucontainer}>
                <div ref={topRef} className={styles.header}>
                    <div className={styles.header_logo}
                        onClick={(e: any) => {
                            e.preventDefault();
                        }}>
                        <div>
                            <div className={styles.header_logo_svg}>
                         {/*       <img src="headerCNAM.png" alt="Logo" />
                          */}
                            </div>
                        </div>
                    </div>
                    <div className={styles.topRightButton}>
                        <GenericIconButton
                            icon='light/times.svg'
                            hoverEnabled={true}
                            width='28px'
                            height='28px'
                            onClick={(e: any) => {
                                scrollBack();
                            }}
                        />
                    </div>
                </div>
                <div className={styles.menubody}>
                    {/* Vervang de bestaande footer hier door de nieuwe footer uit het tweede bestand */}
                    <footer className={styles.footer}>
                        <div style={footerStyle}>
                            <p>
                                <hr style={hrStyle} />
                                <span style={leftLinkStyle}>
                                    <a
                                        style={linkStyle}
                                        href="https://documentation.arts-et-metiers.net"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Catalogue documentaire
                                    </a>
                                </span>
                                <span style={middleLinkStyle}>
                                    <a
                                        style={linkStyle}
                                        href="https://phototheque.arts-et-metiers.net/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        La Banque d’images
                                    </a>
                                </span>
                                <span style={rightMostLinkStyle}>
                                    <a
                                        style={linkStyle}
                                        href="https://www.arts-et-metiers.net/musee/mentions-legales"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Mentions légales
                                    </a>
                                </span>
                                <span style={rightLinkStyle}>
                                    <a
                                        style={linkStyle}
                                        href="https://collections.arts-et-metiers.net/?queryId=a876c7f1-2a5f-4f8f-bf8a-f43deff1649c"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Crédits
                                    </a>
                                </span>
                                <span style={rightLinkStyle}>
                                    <a
                                        style={linkStyle}
                                        href="https://www.arts-et-metiers.net/musee/contacts"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Contacts
                                    </a>
                                </span>
                            </p>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
};

export default Menu;
